export default __webpack_public_path__ + "static/media/back.5cc7f01b.svg";